import React, { useState } from 'react';
import DebounceTextInput from 'components/DebounseTextInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import IndianAddonsTable from './components/IndianAddonsTable';
// import AdvancedFilters from 'components/AdvancedFilters';
// import SubscriptionPlanFilter from 'pages/SubscriptionPlans/components/SubscriptionPlanFilter';

// const initialValues = {
//   planName: null,
// };
const IndianAddons = ({ toggleDeleteRecord, handleClickEdit }) => {
  const [searchString, setSearchString] = useState('');
  // const [filterValue, setFilterValue] = useState([]);
  // const statusFilter = {
  //   key: 'status',
  //   value: 'ALL',
  //   type: 'STRING',
  //   op: 'EQ',
  // };
  const handleChange = (value) => {
    setSearchString(value);
  };
  // const handleFilters = (val) => {
  //   setFilterValue([
  //     {
  //       key: 'planName',
  //       value: val?.planName?.planName ? val?.planName?.planName : '',
  //       type: 'STRING',
  //       op: 'LIKE',
  //     },
  //   ]);
  // };
  return (
    <div>
      {' '}
      <ErrorBoundary>
        <DebounceTextInput
          onInputChange={handleChange}
          delay={500} // Set your desired delay in milliseconds
          value={searchString}
          placeholder="Search by Plan"
          positionRight="20px"
          positionTop="-50px"
        />

        <IndianAddonsTable
          searchString={searchString}
          handleClickEdit={handleClickEdit}
          toggleDeleteRecord={toggleDeleteRecord}
        />
      </ErrorBoundary>
    </div>
  );
};

export default IndianAddons;
